import React, { useEffect, useState } from "react";
import DateRange from "../DateRange/DateRange";
import { dashboardIcon } from "../../assets/img";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";

export const AdminProfit = () => {
  const [isActive, setIsActive] = useState("Before Tax");

  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  const [isData, setIsData] = useState({});
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : { from: "", to: "" }
  );

  const getTopCard = async () => {
    let url = URLS.DASHBOARPROFIT_CARD;
    const params = [];

    if (selectedFilter.from && selectedFilter.to) {
      params.push(`from_date=${selectedFilter.from}`);
      params.push(`to_date=${selectedFilter.to}`);
    }

    if (params.length > 0) url += `?${params.join("&")}`;

    try {
      let res = await get(url);
      if (res?.status === "success") {
        setIsData(res?.data ?? {});
      }
    } catch (error) {
      console.error("Error fetching profit data:", error);
    }
  };

  useEffect(() => {
    getTopCard();
  }, [selectedFilter.from, selectedFilter.to]);

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0,0,0,0.1)", // lighter
        borderRadius: "8px", // smaller
        height: "100%",
      }}
    >
      {/* Admin Profit + Date */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            margin: 0,
          }}
        >
          Admin Profit
        </p>

        <div className="d-flex ac-jb mt-2 gap-1 flex-wrap">
          <DateRange
            setFromDate={(date) => handleChangeFilter("from", date)}
            setToDate={(date) => handleChangeFilter("to", date)}
          />
        </div>
      </div>

      {/* Overall Profit */}
      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
          position: "relative",
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
            }}
          >
            Overall Profit
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            {isActive === "Before Tax"
              ? (isData?.overall_profit?.before_tax || 0)?.toFixed(2)
              : (isData?.overall_profit?.after_tax || 0)?.toFixed(2)}
          </p>
        </div>

        <div style={{ width: "26px", height: "26px" }}>
          {" "}
          {/* smaller */}
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>

        {/* Before/After Tax Toggle */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            display: "flex",
            flexDirection: "row",
            gap: 8, // smaller
            right: 0,
            background: "#EFEFEF",
            padding: 4, // smaller
            borderRadius: "8px", // smaller
            alignItems: "center",
          }}
        >
          {["Before Tax", "After Tax"].map((item) => (
            <div
              key={item}
              style={{
                background: isActive === item ? "#FFF" : "#EFEFEF",
                padding: 6, // smaller
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => setIsActive(item)}
            >
              <p style={{ margin: 0, fontSize: "12px" }}>{item}</p>{" "}
              {/* smaller */}
            </div>
          ))}
        </div>
      </div>

      {/* Total Section */}
      <p
        style={{
          marginTop: "8px",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        {[
          { label: "Booking Profit", key: "booking_profit" },
          { label: "MMC Profit", key: "mmc_profit" },
          { label: "Tips Profit", key: "tips_profit" },
          { label: "Cancellation Profit", key: "cancellation_profit" },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              padding: "8px 10px", // smaller
              width: "48%",
              borderRadius: "8px", // smaller
              marginBottom: "8px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>
              {isActive === "Before Tax"
                ? (isData?.[item.key]?.before_tax || 0)?.toFixed(2)
                : (isData?.[item.key]?.after_tax || 0)?.toFixed(2)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
